import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const placeBetVideoPokerService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/video-poker-game/place-bet', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const getMyBetsService = (data) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/video-poker-game/my-bets', data, {
    params: data,
    server: microServices.SERVICE_URL_1
  })
}

export const getUnfinishedBetService = () => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/video-poker-game/unfinished-bet', {
    params: {},
    server: microServices.SERVICE_URL_1
  })
}

export const dealVideoPokerService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/video-poker-game/deal', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}
